<template>
  <div class="th">
    <slot></slot>
  </div>
</template>
